module.exports = __webpack_public_path__ + "components/flag/static/square/bb-0cfa0ed65ac7ab6e137102b1da7299ab.svg";